import { useEffect, useContext } from "react";
import { useHistory } from "react-router-dom";
import { useParams } from "react-router";
import { useAuthorizeHandsoffQueryParams } from "../../hooks/site-credentials/useAuthorizeQueryParams";
import LoadingLogo from "@/components/loading-logo/loading-logo";

import { DigitalAsset } from "@/models/site-credentials/common/DigitalAsset";
import { DigitalAssetContext } from "../../contexts/site-credentials/DigitalAssetContext";
import { genericService } from "@/services/GenericService";
import { Config } from "@/config/Config";
import { AuthorizeHandsoffResponse } from "@/models/AuthorizeResponse";

export default function AuthorizationHandsoff() {
  const history = useHistory();
  let params = useParams<{ key: string }>();

  const key = params.key;

  const authorizeQueryParams = useAuthorizeHandsoffQueryParams();

  const digitalAssetContext = useContext(DigitalAssetContext);

  useEffect(() => {
    const authorize = async () => {

      const params = new URLSearchParams({
        language: authorizeQueryParams.language || "",
      });

      const resp = await genericService.get<AuthorizeHandsoffResponse>(
        `${Config.SiteCredentials.authorizeUrl}/${key}`
      )

      if (resp.kind === "success") {
        const digitalAssetResult = await genericService.get<DigitalAsset>(
          `${Config.ContinenteCredentials.digitalAssetUrl}/${resp.value.client_id}`
        );

        if (digitalAssetResult.kind === "success") {
          digitalAssetContext.updateDigitalAsset(
            digitalAssetResult.value as DigitalAsset
          );
        }

        history.push(`${resp.value.url}?${params}`,
          {
            nextStep: "/api" + resp.value.url,
            from: resp.value.deeplink_action ? "dl" : ""
          });
      }
    };

    authorize();
  }, [
    authorizeQueryParams.language,
    digitalAssetContext,
    history,
  ]);

  return (
    <>
      <LoadingLogo />
    </>
  );
}
